import { render } from "./ListeAffectationPage.vue?vue&type=template&id=919818ca&ts=true"
import script from "./ListeAffectationPage.vue?vue&type=script&lang=ts"
export * from "./ListeAffectationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__